module.exports = __webpack_public_path__ + "assets/images/reading-risk.5f86863a29d03ed69cb9c42b1128c01f.svg";